'use strict'
const React = require('react')
const styles = require('./contact.css')

class LoginPrompt extends React.PureComponent {
  render() {
    return (
      <div>
        <h1 className={styles.mainHeader}>Contact Us</h1>
        <p className={styles.description}>You need to be signed in to get help with npm.</p>

        <a href="/login?next=/support" className={styles.login}>
          Sign in for assistance
        </a>

        <hr className={styles.contact} />

        <h2 className={styles.header}>Can&apos;t sign in, or don&apos;t have an account?</h2>
        <p>Choose one of these categories to continue.</p>

        <div className={styles.noaccount}>
          <a href="?inquire=account" className={styles.noaccountlink}>
            Account or billing issues
          </a>
          <a href="/policies/dmca" className={styles.noaccountlink}>
            Copyright or trademark data removal
          </a>
          <a href="?inquire=naming-dispute" className={styles.noaccountlink}>
            Dispute a package, org, or username
          </a>
          <a href="?inquire=security" className={styles.noaccountlink}>
            Report a security issue or abuse
          </a>
        </div>
      </div>
    )
  }
}

module.exports = LoginPrompt
